module.exports = __webpack_public_path__ + "static/img/car-en.9d4691a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/car-en.png
// module id = v1QN
// module chunks = 1